export const CustomerModels = {
  EMBEDDED: 'EMBEDDED',
  NESTED: 'NESTED',
} as const

export type CustomerModel = (typeof CustomerModels)[keyof typeof CustomerModels]

export type ConfirmCustomerDetail = {
  label: string
  value: string
}
